import { render } from "./StartingPoint.vue?vue&type=template&id=340f7ee9&scoped=true"
import script from "./StartingPoint.vue?vue&type=script&lang=js"
export * from "./StartingPoint.vue?vue&type=script&lang=js"

import "./StartingPoint.vue?vue&type=style&index=0&id=340f7ee9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340f7ee9"]])

export default __exports__